let config = {
  "dashboardScreen viewed":{
    "action":"viewed",
    "subject":"dashboardScreen",
    "source":"dashboardScreen"
  },
  "mapView filtered":{
    "action":"filtered",
    "subject":"mapView",
    "source":"dashboardScreen",
    "attributes":{
      "filter":"the filter that was used or null value if no filters were used (\"overdue\" | \"ongoingTests\" | \"testingSoon\" | \"compliant\" | \"noAfss\" | null)"
    }
  },
  "mapPin selected":{
    "action":"selected",
    "subject":"mapPin",
    "source":"dashboardScreen",
    "attributes":{
      "buildingId":"(String) the building ID of the selected pin"
    }
  },
  "buildingLink clicked":{
    "action":"clicked",
    "subject":"buildingLink",
    "source":"dashboardScreen",
    "attributes":{
      "dashboardSection":"where the link was clicked (mapView | calendar | recentActivity | allBuildings)"
    }
  },
  "goToBuildingButton clicked":{
    "action":"clicked",
    "subject":"goToBuildingButton",
    "source":"dashboardScreen"
  },
  "allBuildings sorted":{
    "action":"sorted",
    "subject":"allBuildings",
    "source":"dashboardScreen",
    "attributes":{
      "column":"the column that was sorted by (buildingName | deviceStatus | nextTestDate | afssDate | latestTestReport | latestTestDate)",
      "order":"the sorting order (asc | dsc)"
    }
  },
  "maintenanceRecord opened":{
    "action":"opened",
    "subject":"maintenanceRecord",
    "source":"dashboardScreen",
    "attributes":{
      "buildingId":"(String) the building ID of the building where maintenance was performed",
    }
  },
  "testReport opened":{
    "action":"opened",
    "subject":"testReport",
    "source":"dashboardScreen",
    "attributes":{
      "buildingId":"(String) the building ID of the building where test was run",
      "reportDate":"the date and time that the test finished (YYYY-MM-DDTHH",
      "reportType":"the type of test report (6monthly | 12monthly | partialTest)",
      "reportResult":"passed | failed",
      "dashboardSection":"where the test report link was clicked (calendar | allBuildings)"
    }
  },
  "pagination clicked":{
    "action":"clicked",
    "subject":"pagination",
    "source":"dashboardScreen",
    "attributes":{
      "list":"(String) the list of paginated content (recentActivities)",
      "page":"(int) page number",
      "pageSize":"(int) number of items on the page"
    }
  }
};

config["mapView filtered"]["attributes"]["filter"] = (field) => {
  return {
    'overdue': 'overdue',
    'ongoing tests': 'ongoingTests',
    'testing soon': 'testingSoon',
    'compliant': 'compliant',
    'no afss': 'noAfss',
    'n/a': null,
    'reset': 'reset'
  }[field.toLowerCase()];
};

config["allBuildings sorted"]["attributes"]["column"] = (field) => {
  field = Array.isArray(field) ? field.join(",") : field;

  return {
    'search': 'buildingName',
    'status_error,status_warning,status_ok': 'deviceStatus',
    'test_future_execution_date': 'nextTestDate',
    'test_latest_afss_dead_line': 'afssDate',
    'test_report': 'latestTestReport',
    'test_report_execution_date': 'latestTestDate',
  }[field];
};


config["testReport opened"]["attributes"]["reportType"] = (field) => {
  return {
    'six-months': '6monthly',
    'annual': '12monthly',
    'repair': 'partialTest',
  }[field];
};

export default () => config;